import React from 'react';

interface FormattedDateProps {
  date: string | Date;
}

const FormattedDate: React.FC<FormattedDateProps> = ({ date }) => {
  const d = new Date(date);

  const day = d.getDate();
  const month = d.toLocaleString('pt-BR', { month: 'long' });
  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');

  return (
    <span>
      {day} de {month} às {hours}:{minutes}
    </span>
  );
};

export default FormattedDate;
